import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export function useAction (action, payloadFn, extraPayload = undefined) {
  const dispatch = useDispatch()
  const dispatchAction = useCallback(
    (payload) => {
      const finalPayload = extraPayload
        ? { ...extraPayload, ...payloadFn(payload) }
        : payloadFn(payload)
      return dispatch(action(finalPayload))
    },
    [action, dispatch, extraPayload, payloadFn]
  )

  return dispatchAction
}

export function useAsyncAction (action) {
  const dispatch = useDispatch()

  const dispatchAction = useCallback(
    (payload) => dispatch(action(payload)),
    [action, dispatch]
  )
  return dispatchAction
}
